/**
 * متن‌های مشترک رابط کاربری (UI copy)
 * برای حفظ یکدستی، پیام‌های پرتکرار از این فایل استفاده شوند.
 */

/** پیام واحد حالت خالی (Empty State) در کل داشبوردها */
export const EMPTY_STATE_MESSAGE = 'داده‌ای برای نمایش وجود ندارد';

/** پیام واحد بارگذاری */
export const LOADING_MESSAGE = 'در حال بارگذاری…';

/** پیام تکمیلی هنگام بارگذاری */
export const PLEASE_WAIT_MESSAGE = 'لطفاً صبر کنید…';
